export const livekitRoomRef = { current: null };